import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import { environment } from '@/constants';

function handleChunkLoadError(importPromise) {
  return importPromise.catch((error) => {
    Vue.toasted.error('Network error encountered', {
      duration: null,
      action: {
        text: 'Reload',
        onClick: () => window.location.reload(),
      },
    });

    return error;
  });
}

const routes = [
  {
    path: '/',
    name: 'game',
    component: () =>
      handleChunkLoadError(
        import(/* webpackChunkName: 'game' */ '../views/Game')
      ),
  },

  {
    path: '/settings',
    name: 'settings',
    component: () =>
      handleChunkLoadError(
        import(/* webpackChunkName: 'game' */ '../views/GameSettings')
      ),
  },

  {
    path: '/about',
    name: 'about',
    component: () =>
      handleChunkLoadError(
        import(/* webpackChunkName: 'game' */ '../views/About')
      ),
  },

  {
    path: '*',
    name: 'httpError',
    component: () =>
      handleChunkLoadError(
        import(/* webpackChunkName: 'httpError' */ '../views/HttpError')
      ),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  // See https://router.vuejs.org/guide/advanced/scroll-behavior.html#scroll-behavior
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };

    // Avoid changing scroll position if the base path matches. Makes the UI
    // nicer in some cases like navigating between tabs on the journal.
    if (to.matched[0] === from.matched[0]) {
      return;
    }

    return { x: 0, y: 0 };
  },
});

Vue.use(VueRouter);
Vue.router = router;

router.afterEach((to) => {
  if (to.name !== 'httpError') {
    store.dispatch('setHttpError', null);
  }
});

export default router;
